import { format, isEqual, parseISO } from "date-fns";
import React from "react";
import {
  useCreatePublicHolidayEventMutation,
  useFetchPublicHolidayEventsQuery,
  useFetchPublicHolidayRecommendationsQuery,
} from "store/reducers";

export function PublicHolidayRecommendations() {
  const { data: publicHolidayRecommendations } = useFetchPublicHolidayRecommendationsQuery();
  const { data: publicHolidayEvents } = useFetchPublicHolidayEventsQuery();
  const [createPublicHolidayEvent] = useCreatePublicHolidayEventMutation();

  const filteredEvents = publicHolidayRecommendations?.filter((event) => {
    const dateObject = parseISO(event.date);
    return !publicHolidayEvents?.public_holiday_events.find((existing_event) =>
      isEqual(parseISO(existing_event.date), dateObject),
    );
  });

  const events = () => {
    if (!filteredEvents?.length) {
      return <div>No Events To Recommend</div>;
    }

    return filteredEvents.map((event) => {
      const dateObject = parseISO(event.date);
      const readableDate = format(dateObject, "MMMM dd, yyyy");
      return (
        <div className="grid grid-cols-3 gap-4 mb-1" key={event.date}>
          <div className="text-grey-darker">
            <div>{event.name}</div>
          </div>
          <div className="text-grey-darker">
            <div>{readableDate}</div>
          </div>
          <div>
            <button
              onClick={() =>
                createPublicHolidayEvent({
                  name: event.name,
                  date: event.date,
                })
              }
              className="bg-accent hover:bg-accent text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring"
            >
              Add Event
            </button>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="mt-8">
      <h3 className="text-primary-dark mb-2">Official Public-Holiday Calendar Recommendations</h3>
      {events()}
    </div>
  );
}
